import { render, staticRenderFns } from "./EzLoader.vue?vue&type=template&id=c0af3cee&scoped=true&"
import script from "./EzLoader.vue?vue&type=script&lang=js&"
export * from "./EzLoader.vue?vue&type=script&lang=js&"
import style0 from "./EzLoader.vue?vue&type=style&index=0&id=c0af3cee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0af3cee",
  null
  
)

export default component.exports